import { getRequestLogs, RequestLog } from "@api";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Modal } from "@components";

const useStyles = makeStyles({
  dialog: {
    borderLeft: "3px solid #F1B66A",
  },
  icon: {
    position: "absolute",
    right: "1px",
    top: "1px",
    color: "black",
  },
  dialogContent: {
    width: "fit-content",
    height: "200px",
  },
  tableHead: {
    backgroundColor: "#55575A",
  },
  table: {},
  tableHeadCell: {
    color: "#EAEAEB",
    padding: "5px",
  },
  tableBodyCell: {
    padding: "5px",
    border: "1px solid black",
  },
});

interface Props {
  isOpen: boolean;
  closeModal?: () => void;
  headerId: number;
}

export const ModalHistoryUserRequest: React.FC<Props> = ({
  isOpen,
  closeModal = () => {},
  headerId,
}) => {
  const classNames = useStyles();
  const title = `Logs - ${headerId}`;

  const [requestHistoryLogs, setRequestHistoryLogs] = useState<RequestLog[]>(
    []
  );

  useEffect(() => {
    (async () => {
      try {
        const entires = await getRequestLogs(headerId);
        setRequestHistoryLogs(entires);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [headerId, isOpen]);
  const cellContentStyle = { width: "150px" };
  return (
    <Modal
      isOpen={isOpen}
      title={`${title}`}
      size="md"
      height="lg"
      closeModal={() => closeModal()}
    >
      <Box className={classNames.dialogContent}>
        <TableContainer>
          <Table className={classNames.table}>
            <TableHead className={classNames.tableHead}>
              <TableRow>
                <TableCell className={classNames.tableHeadCell}>
                  Added By
                </TableCell>
                <TableCell className={classNames.tableHeadCell}>
                  Date and Time Added
                </TableCell>
                <TableCell className={classNames.tableHeadCell}>
                  Log Type
                </TableCell>
                <TableCell className={classNames.tableHeadCell}>
                  Remarks
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requestHistoryLogs.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell style={cellContentStyle}>{row.addedBy}</TableCell>
                  <TableCell style={cellContentStyle}>
                    {format(new Date(row.dateTime), "PPpp")}
                  </TableCell>
                  <TableCell style={cellContentStyle}>{row.logType}</TableCell>
                  <TableCell>{row.remarks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Modal>
  );
};
